import {  ccxHistoricalMetrics } from "../../Data/db";
import { Checkbox, Stack} from '@chakra-ui/react';

const CCXHistoricalMetricSelector = ({tempWidget, setTempWidget}) => {


    const handleChange = (metricName) => {
            let newStatArray = [];
            newStatArray.push(metricName);
            
            let updatedWidgetObject = {...tempWidget};
            updatedWidgetObject['statistic'] = newStatArray;
            updatedWidgetObject['type'] = 'CCX historical';
            setTempWidget(updatedWidgetObject);
    }; 

    return (

        <Stack spacing={3} direction='column'>
            {ccxHistoricalMetrics.map((metric, i) => {
                return (
                    <Checkbox
                        name={metric.Name}
                        key={`${i}=${metric.Name}`}
                        isChecked={tempWidget.statistic.includes(metric.Name)}
                        onChange={(e) => handleChange(metric.Name)}
                    >
                        {metric.Name}
                    </Checkbox>
                );
            })}
        </Stack>
    );
};

export default CCXHistoricalMetricSelector;